import ExitIntentModals from './ExitIntentModals';

export default ExitIntentModals;
